import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const adminBookingEnum = z
  .enum([
    "all",
    "active",
    "client-unpaid",
    "tutor-unpaid",
    "2023",
    "2024",
    "2025",
    "2026",
    "class",
    "advising",
    "peer-tutoring",
  ])
  .optional()
  .default("active");

export type AdminBookingStatus = z.infer<typeof adminBookingEnum>;

export const Route = createFileRoute("/admindashboard/_layout/events")({
  validateSearch: z.object({
    status: adminBookingEnum,
    page: z.number().min(1).optional().default(1),
    pageSize: z.number().min(1).optional().default(100),
    eventType: z.string().optional(),
    userId: z.string().optional(),
    staffId: z.string().optional(),
  }),
});
